import React, { useMemo } from 'react';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

const AppVersionProvider: React.FC<any> = (props: any) => {
    const isChromeVersionLessThan90 = useMemo(() => {
        const userAgent = navigator.userAgent;
        const chromeMatch = userAgent.match(/Chrome\/(\d+)/);

        if (chromeMatch && chromeMatch.length > 1) {
            const chromeVersion = parseInt(chromeMatch[1], 10);
            return chromeVersion < 90;
        }

        return false;
    }, []);

    return isChromeVersionLessThan90 ? (
        <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
            {props.children}
        </StyleProvider>
    ) : (
        props.children
    );
};

export default AppVersionProvider;
